const NOME_PROJETO = 'MCCAIN';
const TEXTO_SEM_DADOS = 'Sem dados para exibir';

export { NOME_PROJETO, TEXTO_SEM_DADOS };
